import type { Signal } from "./types";

/**
 * Five rapid observational signals. Each option maps 1:1 to one Enneagram type.
 * Source: docs of Instituto Rafa Medeiros — `09-nove-personalidades.md`
 * Tabela "Estilos de Comunicação por Personalidade" (linha 297-307) e seções
 * de comportamento na consulta C1-C9.
 */
export const SIGNALS: Signal[] = [
  {
    id: "tom",
    prompt: "Tom de voz do paciente",
    helper: "Como ele soou nos primeiros 1-2 minutos?",
    options: [
      { type: 1, label: "Sério, firme, pausado" },
      { type: 2, label: "Caloroso, amigável, envolvente" },
      { type: 3, label: "Firme, objetivo, direto" },
      { type: 4, label: "Expressivo, reflexivo, pausado" },
      { type: 5, label: "Neutro, calmo, sem variação" },
      { type: 6, label: "Hesitante, soa inseguro" },
      { type: 7, label: "Rápido, animado, entusiasmado" },
      { type: 8, label: "Firme, impositivo, dominante" },
      { type: 9, label: "Devagar, suave, baixa energia" },
    ],
  },
  {
    id: "ritmo",
    prompt: "Ritmo e padrão de fala",
    helper: "Como ele estrutura o que diz?",
    options: [
      { type: 1, label: "Vocabulário técnico, pede muitos detalhes" },
      { type: 2, label: "Cria conexão pessoal antes de falar do problema" },
      { type: 3, label: "Fala rápido, sem rodeios, lista conquistas" },
      { type: 4, label: "Reflexivo, metafórico, suspira antes de responder" },
      { type: 5, label: "Monossilábico, ouve antes de falar" },
      { type: 6, label: "Pergunta várias vezes sobre riscos e garantias" },
      { type: 7, label: "Salta tópicos, interrompe com histórias próprias" },
      { type: 8, label: "Faz perguntas desafiadoras, testa autoridade" },
      { type: 9, label: "Concorda com tudo, evita confronto" },
    ],
  },
  {
    id: "frase",
    prompt: "Frase espontânea mais próxima da que ele disse",
    helper: "Escolha a assinatura linguística mais parecida",
    options: [
      { type: 1, label: '"Quero um planejamento detalhado com etapas e prazos."' },
      { type: 2, label: '"Adoro o seu trabalho! O que sugerir eu sigo."' },
      { type: 3, label: '"Em quanto tempo verei o resultado?"' },
      { type: 4, label: '"Não quero algo padronizado, quero algo que combine comigo."' },
      { type: 5, label: '"Você tem algum artigo científico ou estudo sobre isso?"' },
      { type: 6, label: '"E se algo der errado? Existe garantia?"' },
      { type: 7, label: '"Adoro novidades! Quais são as últimas tendências?"' },
      { type: 8, label: '"Quero saber se isso realmente é superior às outras técnicas."' },
      { type: 9, label: '"Não sei se esse é o momento certo para mim."' },
    ],
  },
  {
    id: "postura",
    prompt: "Postura, aparência, presença",
    helper: "Como ele se apresenta no consultório?",
    options: [
      { type: 1, label: "Organizado, atento a detalhes, posto pra critica" },
      { type: 2, label: "Afetuoso, toca, pergunta sobre você/família" },
      { type: 3, label: "Impecável, status visível (relógio, terno)" },
      { type: 4, label: "Único, artístico, estética singular" },
      { type: 5, label: "Reservado, observador, distante" },
      { type: 6, label: "Inquieto, ansioso, pesquisa no celular" },
      { type: 7, label: "Extrovertido, alta energia, expansivo" },
      { type: 8, label: "Imponente, intimidador, ocupa espaço" },
      { type: 9, label: "Relaxado, baixa energia, postura passiva" },
    ],
  },
  {
    id: "decisao",
    prompt: "Como sinaliza que decide",
    helper: "O que ele precisa para fechar?",
    options: [
      { type: 1, label: "Pede precisão e protocolo passo a passo" },
      { type: 2, label: "Quer agradar, espera você dar permissão" },
      { type: 3, label: "Quer resultado e prazo, performance" },
      { type: 4, label: "Quer algo único, criado para ele" },
      { type: 5, label: "Pede evidência científica, dados, estudos" },
      { type: 6, label: "Pede garantia escrita, contrato, segurança" },
      { type: 7, label: "Quer novidade, tendência, dinâmica" },
      { type: 8, label: "Testa autoridade, quer poder e controle" },
      { type: 9, label: "Concorda passivo, precisa de impulso externo" },
    ],
  },
];

export const SIGNAL_IDS = SIGNALS.map((s) => s.id);
